import { registerComponents } from '@/utils/component'
import appButton from './appButton.vue'
import appDisplay from './appDisplay.vue'
import appTitle from './appTitle.vue'
import appIcon from './appIcon.vue'
import appToast from './appToast.vue'
import iconArrowRight from './icons/arrowRight'
import headBanner from './headBanner.vue'
import outboxCon from './outbox-con.vue'

// icons list below
const icons = {
  appIcon,
  iconArrowRight
}

// components list below
const components = {
  appButton,
  appDisplay,
  appTitle,
  appToast,
  headBanner,
  outboxCon
}

export default {
  install (Vue, options) {
    registerComponents(Vue, icons)
    registerComponents(Vue, components)
  }
}
